<template>
  <div class="closeshop">
    <div class="left-box">
      <leftPage :active="6" :org_id="org_id"/>
    </div>
    <div class="right-box">
      <div class="title-box">
        <div class="tit-left">
          <div class="icon-box">
            <i class="iconfont icon-wodeshensu"></i>
          </div>
          <b>申请闭店</b>
        </div>
        <div class="download-box">
          <a :href="fileUrl +'/uploads/closeApply.doc'" class="btn" download="申请闭店相关模板" target="_blank">申请闭店相关模板</a>
        </div>
      </div>

      <div class="tips">
        注：申请闭店填报信息涉及的相关模板请点击右上角下载
      </div>

      <div class="up-box">
        <div class="tex">1.退出科技类校外培训机构申请书</div>
        <a :href="close_file" target="_blank" download
           v-if="close_file"
           class="look">查看申请书</a>
        <upload-file
          class="upZuj"
          name="close_file"
          @uploadFile="uploadFile"
        >
          <div class="btnUp" slot="upload">
            <i class="iconfont icon-iconfontzhizuobiaozhun0263"></i> 上传申请书
          </div>
        </upload-file>
        <div class="desc">根据提供的模板上传签字盖章的扫描件</div>
      </div>

      <div class="up-box">
        <div class="tex">2.退出科技类校外培训机构承诺书</div>
        <a :href="close_doc" target="_blank" download
           v-if="close_doc"
           class="look">查看申请书</a>
        <upload-file
          class="upZuj"
          name="close_doc"
          @uploadFile="uploadFile"
        >
          <div class="btnUp" slot="upload">
            <i class="iconfont icon-iconfontzhizuobiaozhun0263"></i> 上传承诺书
          </div>
        </upload-file>
        <div class="desc">根据提供的模板上传签字盖章的扫描件</div>
      </div>
      <div class="sub-btn">
        <div class="btn" @click="sub">提交</div>
      </div>
    </div>
  </div>
</template>
<script>
import leftPage from "@/views/admin/pages/orgDetail/common/leftPage";
import UploadFile from "@/components/UploadFile";
import {fileUrl} from "@/config";
import {
  save_close,
  get_org_close
} from '@/api/admin'
export default {
  name: "closeshop",
  data() {
    return {
      fileUrl: fileUrl,
      org_id: '',
      close_file:'', // 退出科技类校外培训机构申请书
      close_doc:'',  //  退出科技类校外培训机构承诺书
    }
  },
  components: {
    leftPage,
    UploadFile
  },
  created() {
    this.$emit("setActive", {
      headActive: 2
    })
    this.org_id = this.$route.query.org_id
    console.log(this.$route.query.org_id)
    this.init()
  },
  methods: {
    async init(){
      let _data = await get_org_close(this.org_id);
      if(_data.status == 200) {
        this.close_file = _data.data.close_file
        this.close_doc = _data.data.close_doc
      }
    },

    async sub(){
      if(!this.close_file) {
        return this.$message.error('请上传申请书')
      }
      if(!this.close_doc) {
        return this.$message.error('请上传承诺书')
      }
      let _data = await save_close(this.org_id,this.close_file,this.close_doc);
      if(_data.status == 200){
        this.$message.success(_data.msg)
      }else{
        this.$message.error(_data.msg)
      }
    },

    uploadFile(data) {
      this[data.name] = data.file.url
    },
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.closeshop {
  width: 100%;
  min-height: calc(100vh - (173px + 159px));
  background: #f3f5f7;
  padding: 20px;
  display: flex;
  justify-content: flex-start;
  .right-box {
    flex: 1;
    margin-left: 25px;
    background-image: linear-gradient(0deg,
      #ffffff 84%,
      #edf6ff 100%);
    border-radius: 8px;
    border: solid 1px #ffffff;
    padding: 0 20px;

    .sub-btn {
      width: 100%;
     display: flex;
      justify-content: center;
      padding: 40px 0;
      .btn {
        width: 120px;
        padding: 0 10px;
        height: 36px;
        margin-left: 10px;
        background-image: linear-gradient(90deg,
          #2791ff 0%,
          #81b6ff 100%);
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #ffffff;
      }
    }

    .desc {
      width: max-content;
      font-size: 18px;
      color: #dc0b0b;
      margin-left: 30px;
    }

    .look {
      width: max-content;
      padding: 0 10px;
      height: 36px;
      border: 1px solid #2791ff;
      color: #2791ff;
      line-height: 34px;
      text-align: center;
      font-size: 14px;
      margin-left: 10px;
      border-radius: 4px;
    }

    .btnUp {
      width: max-content;
      padding: 0 10px;
      height: 36px;
      margin-left: 10px;
      background-image: linear-gradient(90deg,
        #2791ff 0%,
        #81b6ff 100%);
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #ffffff;

      i {
        font-size: 20px;
        color: #ffffff;
        margin-right: 5px;
        font-weight: 100;
      }
    }
    .up-box {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 25px 0;
      border-bottom: 1px solid #e4e4e4;
      .tex {
        font-size: 18px;
        color: #333333;
        width: 380px;
      }
    }

    .tips {
      width: 100%;
      font-size: 16px;
      color: #dc0b0b;
      margin-top: 30px;
    }

    .title-box {
      width: 100%;
      height: 60px;
      border-bottom: solid 2px #e3e7f0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .download-box {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        a.btn {
          width: 150px;
          height: 37px;
          background-image: linear-gradient(0deg, #f59a23 0%, #feb555 100%);
          border-radius: 4px;
          text-align: center;
          line-height: 37px;
          font-size: 16px;
          color: #ffffff;
          cursor: pointer;
        }
      }

      .tit-left {
        display: flex;
        justify-content: flex-start;
        padding-top: 25px;
        padding-bottom: 15px;

        .icon-box {
          width: 30px;
          height: 30px;
          background-image: linear-gradient(-30deg,
            #3579fb 0%,
            #44a3ff 100%);
          box-shadow: 0px 10px 10px 0px rgba(50, 150, 255, 0.3);
          border-radius: 10px;
          text-align: center;
          line-height: 30px;

          i {
            font-size: 17px;
            color: #ffffff;
          }
        }


        b {
          font-size: 22px;
          color: #16181d;
          font-weight: bold;
          margin-left: 5px;

          span {
            font-size: 18px;
            color: #f74945;
          }
        }
      }
    }
  }
  .left-box {
    width: 260px;
  }
}
</style>


